<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
					<input-form-text textInput="Título" :required="true" v-model="form.titulo"
						:value="form.titulo"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right"></label>
						<div class="col-sm-5">
							<file-upload v-if="!allFiles.length" ref="fupload" :url="'/v1/professores-temporarios/upload'" :id="null"
								:label="'PDF até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf"
								:isFile="true"></file-upload>
							<items-edit v-else :files="allFiles" url="/v1/professores-temporarios/upload" id="id"
								:isFile="true"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActive"></footer-button>
		</form>
	</div>
</template>
	
<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Arquivos',
			form: {
				titulo: '',
				professores_id: '', 
				arquivo: '',
				ativo: '1'
			},
			allFiles: [],
			isActiveBtn: false,
			isActive: false,
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.cat) {
				const resp = await req(`/v1/professores-temporarios/details/${this.$route.params.id}/${this.$route.params.cat}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					resp.folder = this.form.folder
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push(`/servicos/professores-temporarios/${this.$route.params.id}`)
			} else {
				const resp = await req(`/v1/professores-temporarios/details/${this.$route.params.id}`, 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.$router.push(`/servicos/professores-temporarios/${this.$route.params.id}`)
				this.getLogsTotal(this.user.id)
			}
			this.isActive = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/professores-temporarios/details/${this.$route.params.id}/${this.$route.params.cat}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.titulo = resp.titulo
			this.allFiles = resp.arquivo ? [{ id: this.$route.params.arq, files: resp.arquivo }] : ''
			this.form.professores_id = resp.professores_id
			this.form.ativo = resp.ativo
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.arq) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		},
		async getDadosGeral() {
			const dados = await req(`/v1/professores-temporarios/${this.$route.params.id}`)
			this.$parent.$parent.$children.filter(i => i.$refs.menuSelecionado)[0].$refs.menuSelecionado[0].to = `/servicos/professores-temporarios/${this.$route.params.id}`
			this.$parent.$parent.$children.filter(i => i.$refs.menuSelecionado)[0].$refs.menuSelecionado[0].$el.textContent = dados.titulo
		},
	},
	mounted() {
		this.verifPermissao()
		this.getDadosGeral()
		if (this.$route.params.cat) {
			this.isActive = true
			this.getDados()
		} else {
			this.form.professores_id = this.$route.params.id
		}
	}
}
</script>
	
<style lang="stylus" scoped>
	
	</style>
	